
























import Vue, { PropType } from 'vue';
import { Icon } from '../../../basic';
import { DropdownItemsOptions, DropdownItemOption } from '../basics/dropdowns.basics.types';
import Dropdown from '../basics/Dropdown/Dropdown.vue';
import DropdownItems from '../basics/DropdownItems/DropdownItems.vue';
import DropdownItemGroup from '../basics/DropdownItemGroup/DropdownItemGroup.vue';
import DropdownItem from '../basics/DropdownItem/DropdownItem.vue';
import DropdownIndicator from '../basics/DropdownIndicator/DropdownIndicator.vue';

const ICON_ACTIVE = 'dropup-active';
const ICON_INACTIVE = 'dropdown-inactive';

export default Vue.extend({
  name: 'SelectDropdown',
  components: {
    Icon,
    Dropdown,
    DropdownItems,
    DropdownItemGroup,
    DropdownItem,
    DropdownIndicator,
  },
  props: {
    options: Array as PropType<DropdownItemsOptions>,
    value: String,
  },
  computed: {
    label(): string | undefined {
      let selected: DropdownItemOption = {
        value: '',
      };
      this.options.forEach((option) => {
        selected = option.find((cur: DropdownItemOption) => this.value === cur.value) || {
          value: '',
        };
      });

      return selected.label ? selected.label : undefined;
    },
  },
  data() {
    return {
      iconActive: ICON_ACTIVE,
      iconInactive: ICON_INACTIVE,
    };
  },
});
